import { render } from "./VitDropdownBar.vue?vue&type=template&id=6a8e822d&ts=true"
import script from "./VitDropdownBar.vue?vue&type=script&lang=ts"
export * from "./VitDropdownBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__